import { Link } from "react-router-dom";
import { classNames } from "../../../lib/class-names";
import Icon from "../icon/icon";
import "./button.scss";

type ButtonPropsT = {
  text: string;
  type: "primary" | "secondary";
  onClick?: () => void;
  href?: string;
  to?: string;
  iconName?: string;
  fullWidth?: boolean;
  fitContent?: boolean;
};

const Button = ({
  text,
  type,
  onClick,
  href,
  to,
  iconName,
  fullWidth,
  fitContent,
}: ButtonPropsT) => {
  const btnClasses = classNames({
    "classic-button": true,
    "classic-button--primary": type === "primary",
    "classic-button--secondary": type === "secondary",
    "classic-button--full-width": !!fullWidth,
    "classic-button--fit-content": !!fitContent,
  });

  const iconClasses = classNames({
    "classic-button__icon": true,
    "classic-button__icon--primary": type === "primary",
    "classic-button__icon--secondary": type === "secondary",
  });

  const content = (
    <>
      {iconName && (
        <Icon name={iconName} size="1.5rem" className={iconClasses} />
      )}
      {text}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={btnClasses}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={btnClasses}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} className={btnClasses}>
      {content}
    </button>
  );
};

export default Button;
